import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import ReportComponent from './ReportComponent';

const ReportTabAreaContainer = styled.div`
  display: grid;
  grid-column: 1;
  grid-row: 1;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 48px 16px;
  min-width: 0;
  min-height: 0;
  width: 100vw;
  box-sizing: border-box;
  padding: 0 3vw;
`;

class SingleComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.renderWithProps = this.renderWithProps.bind(this);
  }

  renderWithProps(props) {
    const params = props.match.params;
    const componentId = params && parseInt(params.componentId, 10);
    const versionString = (params && params.versionString) || 'latest';
    const options =
      (params && params.options && JSON.parse(params.options)) || null;
    return !componentId || !versionString ? null : (
      <ReportTabAreaContainer>
        <ReportComponent
          key={componentId}
          onComponentLoad={() => null}
          reportComponentId={componentId}
          reportVersionString={versionString}
          reportComponentColumns={options && options.columns}
          reportComponentHeightInPx={options && options.height_in_px}
          apiEndpoint={this.props.apiEndpoint}
          isActive={true}
        />
      </ReportTabAreaContainer>
    );
  }

  render() {
    return (
      <Switch>
        <Route exact path={`/components`} render={this.renderWithProps} />
        <Route
          exact
          path={`/components/:componentId`}
          render={this.renderWithProps}
        />
        <Route
          exact
          path={`/components/:componentId/v`}
          render={this.renderWithProps}
        />
        <Route
          exact
          path={`/components/:componentId/v/:versionString`}
          render={this.renderWithProps}
        />
        <Route
          exact
          path={`/components/:componentId/v/:versionString/options`}
          render={this.renderWithProps}
        />
        <Route
          exact
          path={`/components/:componentId/v/:versionString/options/:options`}
          render={this.renderWithProps}
        />
      </Switch>
    );
  }
}

export default SingleComponent;
